import { ITeam } from "./team";
import { IUser } from "./user";

export enum CertificateStatus {
  WAITING = 'waiting',
  GENERATED = 'generated'
}

export interface ICertificate {
  id?: number;
  name?: string;
  email?: string;
  trainerId?: number;
  teamId: number;
  issueDate: Date;
  expirationDate?: Date;
  status?: CertificateStatus;
  hash?: string;
  team?: ITeam;
  trainer?: IUser;
  file?: File
  key?: string
}